(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.trans = this.dataset.trans;
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.menuheight = document.querySelector('.menu_both_bottom');
      this.headersub = document.querySelector('.header-wrapper');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();

      window.matchMedia('(max-width: 992px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.onScroll();
    }

    setHeaderHeight() { 
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      // if (scrollTop != 0) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top || scrollTop < this.header.offsetHeight) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if(this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kkm-smart-feed"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.KKMProgressiveHomepage) return;

  const state = {
    observer: null,
    queue: Promise.resolve()
  };

  const parseSection = (html) => {
    const template = document.createElement('template');
    template.innerHTML = String(html || '').trim();
    return template.content.firstElementChild;
  };

  const loadSection = async (placeholder) => {
    if (!placeholder || placeholder.dataset.loadState === 'loaded') return;
    if (placeholder.dataset.loadState === 'loading') return;

    const sectionId = placeholder.dataset.sectionId;
    const wrapper = placeholder.closest('.shopify-section');
    if (!sectionId || !wrapper) return;

    placeholder.dataset.loadState = 'loading';

    const requestUrl = new URL(window.location.href);
    requestUrl.hash = '';
    requestUrl.searchParams.delete('section_id');
    requestUrl.searchParams.set('sections', sectionId);

    let lastError = null;

    for (let attempt = 0; attempt < 2; attempt += 1) {
      try {
        const response = await fetch(requestUrl.toString(), {
          credentials: 'same-origin',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
        });

        if (!response.ok) throw new Error('Unable to load homepage section');

        const data = await response.json();
        const html = data?.[sectionId];
        if (!html) throw new Error('Homepage section returned no HTML');

        const replacement = parseSection(html);
        if (!replacement) throw new Error('Homepage section HTML was invalid');

        wrapper.replaceWith(replacement);

        if (window.KKMCartQuantityCoordinator?.syncRoot) {
          window.KKMCartQuantityCoordinator.syncRoot(replacement).catch(() => {});
        }

        document.dispatchEvent(new CustomEvent('kkm:progressive-section-loaded', {
          detail: { sectionId, element: replacement }
        }));

        return;
      } catch (error) {
        lastError = error;
        if (attempt === 0) {
          await new Promise((resolve) => window.setTimeout(resolve, 900));
        }
      }
    }

    placeholder.dataset.loadState = 'error';
    placeholder.removeAttribute('aria-busy');
    if (lastError) console.error(lastError);
  };

  const enqueue = (placeholder) => {
    if (!placeholder || placeholder.dataset.queued === 'true') return;
    placeholder.dataset.queued = 'true';
    state.queue = state.queue
      .then(() => loadSection(placeholder))
      .catch((error) => console.error(error));
  };

  const hasCookie = (name) => document.cookie
    .split('; ')
    .some((entry) => entry.startsWith(`${name}=`));

  const init = (root = document) => {
    let placeholders = Array.from(root.querySelectorAll('[data-kkm-progressive-placeholder]'))
      .filter((node) => !node.dataset.queued);

    placeholders
      .filter((node) => node.dataset.feedKey === 'recently-viewed' && !hasCookie('recentlyViewed'))
      .forEach((node) => node.closest('.shopify-section')?.remove());

    placeholders = placeholders.filter((node) => node.isConnected);

    if (!placeholders.length) return;

    placeholders.forEach((node, index) => {
      node.dataset.loadOrder = String(index);
    });

    if (!('IntersectionObserver' in window)) {
      placeholders.forEach(enqueue);
      return;
    }

    if (!state.observer) {
      const rootMargin = window.matchMedia('(min-width: 990px)').matches
        ? '1400px 0px'
        : '900px 0px';

      state.observer = new IntersectionObserver((entries) => {
        entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => Number(a.target.dataset.loadOrder || 0) - Number(b.target.dataset.loadOrder || 0))
          .forEach((entry) => {
            state.observer.unobserve(entry.target);
            enqueue(entry.target);
          });
      }, { rootMargin, threshold: 0.01 });
    }

    placeholders.forEach((node) => state.observer.observe(node));
  };

  window.KKMProgressiveHomepage = { init };

  const start = () => init(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
